import { getSearchParam } from './url';
import { buildUrlEnding } from '../i18n/environments';

export const setCookie = function (cookie_name, cookie_value, cookie_lifespan, customDate) {
  const isLocalHost = window.location.hostname.startsWith('localhost');
  const date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * cookie_lifespan);
  // For localhost and assist-start.net uncomment this line and comment the next one
  // document.cookie = `${cookie_name}=${cookie_value};Secure;Path=/;expires=${date.toGMTString()}`;
  document.cookie = `${cookie_name}=${cookie_value};${!isLocalHost ? `Domain=.zerobounce${buildUrlEnding};Secure;` : ''}Path=/;expires=${
    customDate ? customDate.toGMTString() : date.toGMTString()
  }`;
};

export const getCookie = function (cookie_name) {
  let match = null;
  if (typeof document !== 'undefined') match = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)');
  return match ? match[2] : null;
};

export const initCookies = () => {
  // setCookie('t1', 1, 1);
  // setCookie('ck_init', 'true', 1);

  const gclid = getSearchParam('gclid');
  const repid = getSearchParam('rep-id');
  const term = getSearchParam('utm_term');
  const campaign = getSearchParam('utm_campaign');
  const source = getSearchParam('utm_source');
  const content = getSearchParam('utm_content');
  const medium = getSearchParam('utm_medium');
  const msclkid = getSearchParam('msclkid');
  let referrer = (typeof document !== 'undefined' && document.referrer) || 'direct';
  referrer = referrer === ' ' ? 'space' : referrer;

  if (gclid) {
    const gclsrc = getSearchParam('gclsrc');
    let utmContent = {};

    if (!gclsrc || gclsrc.indexOf('aw') === -1) {
      utmContent = {
        gclid: gclid,
        terms: term,
        campaign: campaign,
        source: source,
        content: content,
        medium: medium,
      };

      setCookie('gclid', gclid, 90);
      setCookie('adUTM', JSON.stringify(utmContent), 90);
      if (msclkid) setCookie('msclkid', msclkid, 90);
    }
  }

  if (!getCookie('referrer_chk')) {
    if (referrer === 'direct' && getSearchParam('referrer')) {
      referrer = getSearchParam('referrer');
    }
    setCookie('referrer_chk', referrer, 90);
    if (typeof window !== 'undefined') setCookie('referrer_landing_chk', window.location.href, 90);
  }

  if (repid) setCookie('rep-id', repid, 90);
};
